import { ReactNode } from 'react';

import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';

import './style.css';

export default function SemiPage({
  children,
  type,
  title,
  extra,
  activeFullPage,
  onToggle,
  loading = false,
  containered = false,
}: {
  children: ReactNode;
  type: string;
  title: string;
  extra?: ReactNode;
  activeFullPage: string | null;
  onToggle: (type: string) => void;
  loading?: boolean;
  containered?: boolean;
}) {
  const isFull = activeFullPage === type;
  const isCollapsed = !!activeFullPage && activeFullPage !== type;

  return (
    <div
      className={`SemiPage-container ${isFull ? 'is-full' : ''} ${isCollapsed ? 'is-collapsed' : ''}`}
    >
      <div className="SemiPage-header">
        <h3 className="SemiPage-header-title">{title}</h3>
        {extra && <div className="SemiPage-header-extra">{extra}</div>}
        <Button
          className="SemiPage-header-toggle"
          icon={isFull ? <CompressOutlined /> : <ExpandOutlined />}
          onClick={() => {
            onToggle(type);
          }}
        />
      </div>
      {!isCollapsed && (
        <div className="SemiPage-content">
          {loading && <Spin />}
          {!loading && containered && (
            <div className="SemiPage-content-inner">{children}</div>
          )}
          {!loading && !containered && children}
        </div>
      )}
    </div>
  );
}
